<template>
<div class="container-fluid">
  <button
    aria-label="close"
    v-if="close_form_button"
    class="close"
    @click="handle_form_close_button_clicked"
  >
    <span aria-hidden="true">&times;</span>
  </button>

  <div class="row justify-content-center">
    <div class="content-modal-sofia col d-flex align-items-center flex-column">
      <h5 class="my-3">{{t('sofia.sofia_form.description')}}</h5>
      <a
        :href="url_for_sofia_info()"
        v-if="info_link_position == 'body'"
        target="_blank"
        class="btn btn-secondary"
      >
        {{t('sofia.sofia_form.more_info')}}
      </a>

      <div class="form_sofia" v-if="!contactSaved">
        <loader-vue :visible="sending_request" />
        <div id ="form-sofia-premium">
          <div class="bg-white border border-info rounded  my-3 p-2">
            <div class="row justify-content-center align-items-center">
              <div clas="col-3">
                <i class="fa fa-lock h2" aria-hidden="true"></i>
              </div>
              <div class="col-9 py-2">
                <span>{{t('sofia.sofia_form.form_description')}}</span>
              </div>
            </div>
          </div>
        </div>

        <commercial-contact-form-vue
          app_source='Sofia'
          @save_request:successful="handleComercialContactSaveRequestSuccessful"
        />

      </div>
      <div v-if="contactSaved" class="w-100">
        <p class="message-success">{{t('sofia.sofia_form.confirmation')}}</p>
        <a href=# @click="resetForm" class="my-3 text-right more-info">{{t('sofia.sofia_form.back_form')}}</a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import mixins from "common/mixins"

export default {
  name: "sofia-premium-form-vue",
  mixins: [mixins.translate, mixins.requests],
  props: {
    close_form_button: { type: Boolean, default: false },
    shadow_animation: { type: Boolean, default: false },
    info_link_position: { type: String, default: 'header' },
  },
  components: {
    "commercial-contact-form-vue": () => import(/* webpackChunkName: "[request]" */ "components/CommercialContactForm"),
    "loader-vue": () => import(/* webpackChunkName: "[request]" */ "components/Loader")
  },
  data() {
    return {
      sending_request: false,
      contactSaved: false 
    }
  },
  methods: {
    handleComercialContactSaveRequestSuccessful() {
      this.contactSaved = true
    },
    handle_form_close_button_clicked() {
      this.$emit("form_close_button:clicked")
    },
    resetForm() {
      this.contactSaved = false
    }
  }
}
</script>
